export default "__VITE_ASSET__DD3SZXt1__"